import { useState } from 'react';
import { FaPlus } from 'react-icons/fa6';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import image01 from '../../../../Images/Gallery/01.jpeg';
import image02 from '../../../../Images/Gallery/02.jpeg';
import image03 from '../../../../Images/Gallery/03.jpeg';
import image04 from '../../../../Images/Gallery/04.jpeg';
import image06 from '../../../../Images/Gallery/06.jpeg';
import image07 from '../../../../Images/Gallery/15.jpeg';
import image08 from '../../../../Images/Gallery/24.jpeg';
import image05 from '../../../../Images/Gallery/27.jpeg';
import SectionTitle from '../../../SectionTitle/SectionTitle';
import './Gallery.css';

const slides = [
  { src: image01 },
  { src: image02 },
  { src: image03 },
  { src: image04 },
  { src: image05 },
  { src: image06 },
  { src: image07 },
  { src: image08 },
];

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  return (
    <section className='pb-[80px] pt-[80px]'>
      <div className='mx-auto px-4 sm:px-6 container lg:px-8'>
        <SectionTitle
          title="Let's Check Our Photo Gallery"
          subtitle='Our Gallery'
        />
        <div className='grid grid-cols-1 gap-5 md:grid-cols-3 lg:grid-cols-4'>
          {slides.map((img, i) => (
            <div className='gallery-item' key={i}>
              <div className='gallery-img'>
                <img src={img.src} alt='gallery' />
              </div>

              <div className='gallery-content'>
                <button
                  className='gallery-link'
                  onClick={() => {
                    setIndex(i);
                    setOpen(true);
                  }}
                >
                  <FaPlus />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox */}
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          index={index}
          slides={slides}
        />
      </div>
    </section>
  );
};

export default Gallery;
